import { Button } from "antd";
import type { ButtonProps } from "antd";

interface IconButtonProps extends ButtonProps { }

export default function IconButton(
    props: IconButtonProps
) {
    return (
        <Button
            {...props}
        />
    )
}
